import { useApplicationParameters } from "src/api/client-api/appParams/useApplicationParameters";

const CMS_FEATURE_FLAG = "FS-cms-enabled" as const;

/**
 * Returns whether the CMS module is enabled for the current tenant.
 *
 * The backend gates every `/api/puck_extensions*` and `/api/cms/puck/page*`
 * route on the `FS-cms-enabled` application parameter. When the flag is off,
 * those routes are not registered and return 404. Frontend hooks that hit
 * those endpoints should consume this hook to short-circuit the React Query
 * `enabled` flag and avoid generating useless 404s.
 */
export const useIsCmsEnabled = (): boolean => {
    const { isFeatureActivated } = useApplicationParameters();
    return isFeatureActivated(CMS_FEATURE_FLAG);
};
